<template lang="pug">
.container
  .error-body.m-auto.align-items-center.d-flex.flex-column.justify-content-center
    .image-animation.position-relative
      svg(id="bg" width="165" height="165" viewBox="0 0 165 165" fill="none" xmlns="http://www.w3.org/2000/svg")
        rect(opacity="0.5" x="131.839" y="17.2633" width="46" height="64" rx="5" transform="rotate(45 131.839 17.2633)" fill="#7190FF")
        rect(opacity="0.5" x="62.542" y="86.5597" width="46" height="64" rx="5" transform="rotate(45 62.542 86.5597)" fill="#7190FF")
        rect(opacity="0.5" x="79.5127" y="35.6481" width="46" height="64" rx="5" transform="rotate(45 79.5127 35.6481)" fill="#06E884")

      #link
        svg(width="167" height="167" viewBox="0 0 167 167" fill="none" xmlns="http://www.w3.org/2000/svg")
          rect(opacity="0.5" x="130.107" y="16.9706" width="46" height="64" rx="5" transform="rotate(45 130.107 16.9706)" stroke="#0A3BE7" stroke-width="6")
          rect(opacity="0.5" x="62.2246" y="84.8528" width="46" height="64" rx="5" transform="rotate(45 62.2246 84.8528)" stroke="#0A3BE7" stroke-width="6")
          path(opacity="0.5" d="M49.4968 63.6396L37.476 75.6605C35.5234 77.6131 35.5234 80.7789 37.476 82.7315L62.9319 108.187C64.8845 110.14 68.0503 110.14 70.0029 108.187L108.187 70.0036C110.139 68.051 110.139 64.8852 108.187 62.9325L82.7308 37.4767C80.7782 35.5241 77.6124 35.5241 75.6598 37.4767L63.639 49.4975" stroke="#0A3BE7" stroke-width="6")
          path(opacity="0.5" d="M46.2365 46.591L35.6299 35.9844" stroke="#0A3BE7" stroke-width="6")
          path(opacity="0.5" d="M52.9547 29.9739L54.3689 41.9947" stroke="#0A3BE7" stroke-width="6")
          path(opacity="0.5" d="M29.9731 52.9549L41.9939 54.3691" stroke="#0A3BE7" stroke-width="6")

    p.text-mono4.error-text.text-center.mb-2 {{ $t("staticSite.eDomain.title") }}
    p.typo-paragraph14.typo-regular-150.text-center {{ $t("staticSite.eDomain.desc") }}
    .btn-group.error-btn.mt-5
      button.btn.btn-default.btn-outline(@click="$chatbox.show")
        svg(class="mr-half" width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg")
          g
            circle(cx="4" cy="4.5" r="4" fill="#3C67FF")
        | {{ $t("generals.liveC" )}}
      router-link.btn.btn-default.btn-primary(:to="{ name: 'Dashboard' }") {{ $t("thanks.back") }}
</template>

<script>
export default {
  name: "ErrorDomain"
};
</script>

<style lang="scss" scoped>
.error-body {
  min-width: 600px;
  // min-height: 378px;
  max-width: 600px;
  // max-height: 378px;
  height: 100vh;

  .image-animation {
    min-width: 168px;
    min-height: 168px;

    #bg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    #link {
      position: absolute;
      top: 44%;
      left: 50%;
      transform: translate(-50%, -50%);

      animation-name: link;
      animation-duration: 2s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;

      transition: all 0.3s ease;
    }
  }

  .error-text {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
  }

  .error-btn {
    button {
      min-width: 180px;
    }
  }
}

@keyframes link {
  50% {
    top: 40%;
  }
}
</style>
